import { render } from "./Unsubscribe.vue?vue&type=template&id=72bd6130&ts=true"
import script from "./Unsubscribe.vue?vue&type=script&lang=ts"
export * from "./Unsubscribe.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__